module.exports = __webpack_public_path__ + "img/schedule-block.cb1ad81a.png";